import React from 'react';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "px-4 py-2 rounded-lg font-medium transition duration-200 flex items-center justify-center gap-2";
  const variants = {
    primary: "bg-[#27489E] text-white hover:bg-[#1e3a7d] shadow-lg shadow-[#27489E]/30",
    secondary: "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50",
    outline: "border-2 border-[#27489E] text-[#27489E] hover:bg-[#27489E]/10",
    ghost: "text-gray-500 hover:text-[#27489E] hover:bg-[#27489E]/10"
  };

  return (
    <button className={`${baseStyle} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
